import React, { Component } from 'react';
import SumaContexto from '../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Row, Col, Tag, Spin } from 'antd';
import Constantes from '../utilidades/Constantes'
import Utilidades from '../utilidades/Utilidades'
import { withCookies } from 'react-cookie';


class InformacionEntidad extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3
    }

    state = {
        cargando: true,
        componente: this.ENUM_COMPONENTE.CARGANDO,
        entidad: undefined,
    };


    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        if (this.props.entidad) {
            this.setSumaState({ entidad: this.props.entidad, cargando: false, componente: this.ENUM_COMPONENTE.VER });
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }


    render() {
        const { componente, entidad } = this.state;

        const wrapperCol = {
            xs: { span: 21, offset: 1 },
            sm: { span: 11, offset: 1 },
        };

        const wrapperCol02 = {
            xs: { span: 22, offset: 1 },
        };

        const colLabel = { sm: { span: 7 } };
        const colTexto = { sm: { span: 17 } };

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>
                            <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                                <div className="seccion-datos">
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Razón social:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.razonSocial : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Tipo sector:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad && entidad.tipoSector ? entidad.tipoSector.tipoSector : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Sigla:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.sigla : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Nit:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? ((entidad.nit ? entidad.nit : '') + ' - ' + (entidad.digitoVerificacion ? entidad.digitoVerificacion : '')) : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Ciudad:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad && entidad.ciudad ? entidad.ciudad.ciudad : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Dirección entidad:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.direccion : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Teléfono:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.telefono : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Móvil:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.celular : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Correo electrónico:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{entidad ? entidad.correoElectronico : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Estado:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <Tag color={
                                                        (entidad && entidad.estadoEntidad.id === Constantes.ENUMS.ESTADO_ENTIDAD.ACTIVO.id)
                                                            ?
                                                            'green'
                                                            :
                                                            (entidad && entidad.estadoEntidad.id === Constantes.ENUMS.ESTADO_ENTIDAD.INACTIVO.id
                                                                ?
                                                                'volcano'
                                                                :

                                                                ''

                                                            )
                                                    } key={entidad ? entidad.estadoEntidad.estadoEntidad : ""}>
                                                        {entidad ? entidad.estadoEntidad.estadoEntidad.toUpperCase() : ""}
                                                    </Tag>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Descripción:</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="row_col_span_texto">
                                        <Col {...wrapperCol02}>
                                            {entidad ? Utilidades.saltoDeLinea(entidad.descripcion) : ''}
                                        </Col>
                                    </Row>
                                    <br/>
                                </div>

                            </Spin>

                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:INFOENT]</label>) : (<></>))
                    )
                }
            </div>
        );
    }
}

export default withRouter(withCookies(InformacionEntidad));